// extracted by mini-css-extract-plugin
module.exports = {"learnMore":"area-form_learnMore__1H9eL","actionButton":"area-form_actionButton__7aNyC"};